import { render, staticRenderFns } from "./PortalResource.vue?vue&type=template&id=53c0a8b4"
import script from "./PortalResource.vue?vue&type=script&lang=js"
export * from "./PortalResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports